<template>
  <van-overlay :show="show" @click="clickClose">
    <div class="contain-bg">
      <div class="contain" @click.stop="">
        <div class="top-bg">恭喜您答对{{ showPopParams.correct }}题！</div>
        <div class="center-bg">
          <div class="title1">获得{{ showPopParams.times }}次抽奖机会</div>
          <!-- <div class="title2">
            <div
              class="item-bg"
              v-for="item in showPopParams.total"
              :key="item">
              <div :class="['item', { active: item <= showPopParams.correct }]">
                +{{ item }}
              </div>
              <div v-show="item < showPopParams.total" class="line"></div>
            </div>
          </div> -->
        </div>
        <div class="bottom-bg">
          <div class="button" @click="clickCommitJoin">
            <div>立即去抽奖</div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>
  <script>
import { Icon, Overlay } from "vant"
export default {
  name: "sevensuccessPop",
  components: {
    [Overlay.name]: Overlay,
    [Icon.name]: Icon
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showPopParams: {}
  },
  data() {
    return {}
  },
  methods: {
    clickClose() {
      this.$emit("close")
    },
    clickCommitJoin() {
      this.$emit("commitUse")
    }
  }
}
</script>
  <style lang="less" scoped>
.van-overlay {
  z-index: 11;
}
.contain-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .contain {
    width: 310px;
    height: 290px;
    display: flex;
    flex-direction: column;
    background-image: url("../../../assets/img/lottery/mid/mid_answer_pop_bg.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .top-bg {
      flex: 1.5;
      display: flex;
      justify-content: center;
      align-items: center;
      color: black;
      font-weight: 900;
      font-size: 25px;
      letter-spacing: 2px;
    }
    .center-bg {
      // padding-top: 20px;
      margin-top: 20px;
      flex: 2;
      display: flex;
      // background-color: aliceblue;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title1 {
        padding-top: 20px;
        color: #999;
        letter-spacing: 4px;
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 20px;
      }
      // .title2 {
      //   display: flex;
      //   width: 100%;
      //   overflow-x: scroll;
      //   justify-content: center;
      //   .item-bg {
      //     display: flex;
      //     justify-content: center;
      //     align-items: center;
      //     text-align: center;
      //     .item {
      //       width: 24px;
      //       height: 24px;
      //       line-height: 24px;
      //       border-radius: 12px;
      //       color: white;
      //       font-size: 11px;
      //       // background-color: #999;
      //       background: url("../../../assets/img/lottery/mid/mid_answer_normal_dot.jpg")
      //         no-repeat;
      //       background-size: 100% 100%;
      //     }
      //     .active {
      //       // background-color: rgb(255, 193, 82);
      //       background: url("../../../assets/img/lottery/mid/mid_answer_select_dot.jpg")
      //         no-repeat;
      //       background-size: 100% 100%;
      //     }
      //     .line {
      //       width: 15px;
      //       height: 1px;
      //       background-color: #999;
      //     }
      //   }
      // }
    }
    .bottom-bg {
      flex: 1.5;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      .button {
        background-image: linear-gradient(
          to bottom,
          rgb(254, 177, 98),
          rgb(255, 142, 69)
        );
        width: 180px;
        height: 38px;
        border-radius: 4px;
        color: rgb(255, 241, 227);
        font-size: 16px;
        font-weight: 800;
        letter-spacing: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>